import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-unitInfoLoader',
    templateUrl: './loader-UnitInfo.component.html',
    styleUrls: ['./loader-UnitInfo.component.scss']
})
export class UnitInfoLoaderComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}
